import React, { useEffect, useState } from 'react';
import { Camera, Check, User, Briefcase, Building2, Sparkles } from 'lucide-react';
interface Props {
  onContinue: () => void;
}
export function OnboardingRecap({
  onContinue
}: Props) {
  const [mounted, setMounted] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 50);
    return () => clearTimeout(t);
  }, []);
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] relative" data-id="element-332">
      <div className="flex-1 overflow-y-auto px-6 pt-12 pb-36" data-id="element-333">
        {/* Header */}
        <div className="mb-10 text-center transition-all duration-700 ease-out" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(20px)',
        transitionDelay: '100ms'
      }} data-id="element-334">
          <h1 className="text-[24px] font-medium text-white mb-2 tracking-tight" data-id="element-335">
            Il tuo profilo è pronto
          </h1>
          <p className="text-[14px] text-[#888888] leading-relaxed max-w-[260px] mx-auto" data-id="element-336">
            Aggiungi una foto per farti riconoscere più facilmente durante il
            Summit.
          </p>
        </div>

        {/* Profile Picture Upload */}
        <div className="flex justify-center mb-10 transition-all duration-700 ease-out" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(20px)',
        transitionDelay: '200ms'
      }} data-id="element-337">
          <button onClick={() => setImageUploaded(!imageUploaded)} className="relative group active:scale-95 transition-transform" data-id="element-338">
            <div className="w-28 h-28 rounded-full bg-[#141414] border border-[#2A2A2A] flex items-center justify-center overflow-hidden transition-all duration-300 group-hover:border-[#C5D82D]/50" data-id="element-339">
              {imageUploaded ? <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face" alt="Profile" className="w-full h-full object-cover" data-id="element-340" /> : <User className="w-10 h-10 text-[#999999] group-hover:text-[#CCCCCC] transition-colors" data-id="element-341" />}
            </div>
            <div className="absolute bottom-0 right-0 w-8 h-8 bg-[#C5D82D] rounded-full flex items-center justify-center border-2 border-[#0D0D0D] shadow-lg" data-id="element-342">
              <Camera className="w-4 h-4 text-[#0D0D0D]" data-id="element-343" />
            </div>
          </button>
        </div>

        {/* Recap Card */}
        <div className="bg-[#141414] border border-[#2A2A2A] rounded-2xl p-5 relative overflow-hidden transition-all duration-700 ease-out" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(20px)',
        transitionDelay: '300ms'
      }} data-id="element-344">
          <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#C5D82D] to-transparent opacity-40" data-id="element-345" />

          <div className="space-y-5" data-id="element-346">
            {/* Role & Org */}
            <div data-id="element-347">
              <h3 className="text-[11px] font-medium text-[#888888] uppercase tracking-wider mb-2 flex items-center gap-1.5" data-id="element-348">
                <Briefcase className="w-3.5 h-3.5" data-id="element-349" />
                Ruolo
              </h3>
              <p className="text-[15px] text-white font-medium" data-id="element-350">
                CEO / Founder
              </p>
              <p className="text-[13px] text-[#888888] flex items-center gap-1.5 mt-1" data-id="element-351">
                <Building2 className="w-3.5 h-3.5" data-id="element-352" />
                EIIS
              </p>
            </div>

            <div className="w-full h-[1px] bg-[#2A2A2A]" data-id="element-353" />

            {/* Themes */}
            <div data-id="element-354">
              <h3 className="text-[11px] font-medium text-[#888888] uppercase tracking-wider mb-2" data-id="element-355">
                Temi di interesse
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-356">
                <span className="px-3 py-1.5 rounded-full bg-[#1A1A1A] border border-[#2A2A2A] text-[#E0E0E0] text-[12px] font-medium" data-id="element-357">
                  Clima e Ambiente
                </span>
                <span className="px-3 py-1.5 rounded-full bg-[#1A1A1A] border border-[#2A2A2A] text-[#E0E0E0] text-[12px] font-medium" data-id="element-358">
                  Tech e Innovazione
                </span>
              </div>
            </div>

            <div className="w-full h-[1px] bg-[#2A2A2A]" data-id="element-359" />

            {/* Project */}
            <div data-id="element-360">
              <h3 className="text-[11px] font-medium text-[#888888] uppercase tracking-wider mb-2 flex items-center gap-1.5" data-id="element-361">
                <Sparkles className="w-3.5 h-3.5 text-[#C5D82D]" data-id="element-362" />
                Progetto
              </h3>
              <p className="text-[14px] text-white font-medium leading-snug mb-1" data-id="element-363">
                Piattaforma di tracciabilità per la filiera del cacao
              </p>
              <div className="flex gap-1.5 mt-2" data-id="element-364">
                <span className="px-2 py-0.5 rounded-md bg-[#C5D82D]/10 text-[#C5D82D] text-[10px] font-medium uppercase tracking-wider" data-id="element-365">
                  Generato dall'AI
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fixed Bottom Bar */}
      <div className="absolute bottom-0 left-0 right-0 bg-[#0D0D0D]/95 backdrop-blur-xl border-t border-[#1A1A1A] px-6 pt-5 pb-8 transition-all duration-700 ease-out" style={{
      opacity: mounted ? 1 : 0,
      transform: mounted ? 'translateY(0)' : 'translateY(16px)',
      transitionDelay: '400ms'
    }} data-id="element-366">
        <button onClick={onContinue} className="w-full bg-[#C5D82D] text-[#0D0D0D] rounded-full py-3.5 font-medium text-[15px] transition-all duration-200 active:scale-[0.98] flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(197,216,45,0.2)]" data-id="element-367">
          Entra nel Summit
          <Check className="w-4.5 h-4.5" strokeWidth={2.5} data-id="element-368" />
        </button>
      </div>
    </div>;
}